import React from "react";
import { useTheme } from "../../context/ThemeContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMoon, faSun } from "@fortawesome/free-solid-svg-icons";

const ThemeButton = () => {
  const { theme, toggleTheme } = useTheme();

  const isDark = theme === "dark";

  return (
    <button
      onClick={toggleTheme}
      className="flex items-center gap-3 px-3 py-2 rounded-full
                 bg-gray-200 dark:bg-gray-800
                 transition-colors"
      aria-label="Toggle theme"
    >
      <div
        className={`w-12 h-6 flex items-center rounded-full p-1 transition-colors
        ${isDark ? "bg-indigo-600" : "bg-yellow-400"}`}
      >
        <div
          className={`bg-white w-4 h-4 rounded-full shadow-md flex items-center justify-center
          transition-all duration-300
          ${isDark ? "translate-x-6" : "translate-x-0"}`}
        >
          <FontAwesomeIcon
            icon={isDark ? faMoon : faSun}
            className={`text-[10px] ${
              isDark ? "text-indigo-500" : "text-yellow-500"
            }`}
          />
        </div>
      </div>
    </button>
  );
};

export default ThemeButton;
